module.exports = __webpack_public_path__ + "static/img/pay_remind_arrow@3x.9a3e2a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay_remind_arrow@3x.png
// module id = NTAx
// module chunks = 1